const getEquipmentObjFromAssignments = ({ unit_bags, unit_build }) => {
  const result = {};

  // Ensure unit_bags is a plain array
  if (!Array.isArray(unit_bags) && typeof unit_bags === 'object') {
    unit_bags = Object.values(unit_bags);
  }
  unit_bags = Array.from(unit_bags || []);

  for (const bagSlot of unit_bags) {
    const bag = bagSlot?.value;
    if (!bag) {
      continue;
    }
    // Ensure bag.items is a plain array
    if (!Array.isArray(bag.items) && typeof bag.items === 'object') {
      bag.items = Object.values(bag.items);
    }
    bag.items = Array.from(bag.items || []);

    for (const slot of bag.items) {
      const item = slot?.value;
      if (!item) {
        continue;
      }
      // TODO(@robertlombardo): optimize (at least check for done & return out of loops)

      for (const [slot, uid] of Object.entries(unit_build.equipment_assignment || {})) {
        if (uid === item.uid) {
          result[slot] = item;
          break;
        }
      }
    }
  }

  return result;
};
module.exports = getEquipmentObjFromAssignments;
